export const getLocalDateString = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const tryReplaceToSlash = (str: string | any) => {
  if (typeof str !== 'string') {
    return str;
  }

  return str.replace(/-/g, '/');
}
